import {
  ACQUISITIONS,
  HOME,
  JOBS,
  NEWS,
  PRESS,
  PROJECT,
  PROJECTS,
} from "./nav/NavigationItems";

import HomeTilt from "./ux/heros/HomeTilt";
import ProjectHero from "./ux/heros/ProjectHero";
import React from "react";

const Header = ({ page, src, alt }) => {
  let hero = <div className="hero-header about-hero"></div>;
  switch (page) {
    case HOME:
      hero = <HomeTilt />;
      break;
    case ACQUISITIONS:
      hero = <div className="hero-header ankaufsprofil-hero"></div>;
      break;
    case JOBS:
      hero = <div className="hero-header jobs-hero"></div>;
      break;
    case NEWS:
    case PRESS:
      hero = <div className="hero-header news-hero"></div>;
      break;
    case PROJECTS:
      hero = <div className="hero-header projekte-hero"></div>;
      break;
    case PROJECT:
      hero = <ProjectHero src={src} alt={alt} />;
      break;
    default:
      <div className="hero-header ankaufsprofil-hero"></div>;
  }
  return <header>{hero}</header>;
};

export default Header;
